angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherDocumentsFaqVideos', function ($http, $log, $sce, EventManager, language, PlatformService, cordovaMessenger) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
    },
    link: function (scope, element) {

      // event manager
      // var eventManager = new EventManager('teacherDocumentsFaqVideos', scope);

      scope.videos = []; // re-defined further down... should move this to a file loaded in from S3

      scope.toggleVideoView = function(video){
        video.isExpanded = !video.isExpanded
        // $log.log('toggle')
      }

      scope.getTranslation = function(id){
        return language.get(id);
      }

      var processVideoLinks = function (){
        _.each(scope.videos, function(video){
          video.iframeSrc = $sce.trustAsResourceUrl(video.videoUrl);
        })
      }
      
      scope.videos = [
        {
          "videoUrl": "https://player.vimeo.com/video/710798778?h=389c174a79&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_2_header",
          "preVideTextTrans": "faq_video_2_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798819?h=077b84c4fc&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_3_header",
          "preVideTextTrans": "faq_video_3_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798854?h=028097de1e&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_4_header",
          "preVideTextTrans": "faq_video_4_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798882?h=3508b6a970&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_5_header",
          "preVideTextTrans": "faq_video_5_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798931?h=18cba6adfa&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_6_header",
          "preVideTextTrans": "faq_video_6_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798973?h=f39bbff766&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_7_header",
          "preVideTextTrans": "faq_video_7_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710799025?h=e47ac1fe82&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_8_header",
          "preVideTextTrans": "faq_video_8_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710799061?h=b76bef076d&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_9_header",
          "preVideTextTrans": "faq_video_9_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710798252?h=861d734fc3&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_10_header",
          "preVideTextTrans": "faq_video_10_pre_vid_text"
        },
        {
          "videoUrl": "https://player.vimeo.com/video/710797974?h=dc20ba1e3b&title=0&byline=0&portrait=0",
          "headerTrans": "faq_video_11_header",
          "preVideTextTrans": "faq_video_11_pre_vid_text"
        },
        {
          "videoUrl": "https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/326/authoring/Video_Meet_the_Developers_final_1_1/1624311378082/Video_Meet_the_Developers_final_1_1.mp4",
          "headerTrans": "faq_video_12_header",
          "preVideTextTrans": "faq_video_12_pre_vid_text"
        }
      ];

      processVideoLinks();


    }
  }
});
